"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LEFT_PANEL_WIDTH", {
    enumerable: true,
    get: function() {
        return LEFT_PANEL_WIDTH;
    }
});
const LEFT_PANEL_WIDTH = 548;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3V0aWxzL2NvbnN0YW50cy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgTEVGVF9QQU5FTF9XSURUSCA9IDU0ODtcbiJdLCJuYW1lcyI6WyJMRUZUX1BBTkVMX1dJRFRIIl0sIm1hcHBpbmdzIjoiOzs7OytCQUFhQTs7O2VBQUFBOzs7QUFBTixNQUFNQSxtQkFBbUIifQ==